import PropTypes from 'prop-types';
import { BsChevronRight, BsMicrosoft, BsServer } from 'react-icons/bs';

import Alert from '#globalComponents/Alert/Alert';
import Panel from '#globalComponents/Overlay/Panel';
import Tag from '#globalComponents/Tag/Tag';

const PROVIDERS = [
	{
		id: 'outlook',
		name: 'Outlook / Office 365',
		description: 'Nutzen Sie Ihr Microsoft-Konto',
		icon: BsMicrosoft,
		badge: 'OAuth2',
	},
	{
		id: 'custom',
		name: 'Eigener SMTP & Gmail',
		description: 'Eigene SMTP-Server-Konfiguration oder Google Gmail',
		icon: BsServer,
		badge: 'SMTP',
	},
];

const ProviderTile = ({ provider, onSelect }) => {
	const Icon = provider.icon;

	return (
		<button
			type="button"
			onClick={() => onSelect(provider.id)}
			className="flex flex-col rounded-card border border-bgBase-500 bg-white p-4 text-left transition-colors hover:border-primary-300 hover:bg-primary-100 focus:outline-none focus:ring-2 focus:ring-primary-300"
		>
			<div className="mb-3 flex items-start justify-between gap-3">
				<div className="flex h-9 w-9 items-center justify-center rounded-control bg-primary-100 text-primary-600">
					<Icon className="h-4 w-4" />
				</div>
				<Tag tone="primary" label={provider.badge} />
			</div>
			<h3 className="text-sm font-semibold text-text">{provider.name}</h3>
			<p className="mt-0.5 text-sm text-bgBase-800">{provider.description}</p>
			<span className="mt-3 flex items-center gap-1 text-sm font-medium text-primary-600">
				Verbinden
				<BsChevronRight className="h-3 w-3" />
			</span>
		</button>
	);
};

ProviderTile.propTypes = {
	provider: PropTypes.shape({
		id: PropTypes.string.isRequired,
		name: PropTypes.string.isRequired,
		description: PropTypes.string.isRequired,
		icon: PropTypes.elementType.isRequired,
		badge: PropTypes.string.isRequired,
	}).isRequired,
	onSelect: PropTypes.func.isRequired,
};

const ProviderSelectionStep = ({ onSelectProvider, onClose }) => (
	<>
		<Panel.Header
			subtitle="Wählen Sie Ihren E-Mail-Provider aus, um ein neues Konto zu verbinden"
			onClose={onClose}
		>
			E-Mail-Provider wählen
		</Panel.Header>

		<Panel.Body>
			<div className="space-y-4">
				<div className="grid grid-cols-1 gap-4 md:grid-cols-2">
					{PROVIDERS.map((provider) => (
						<ProviderTile key={provider.id} provider={provider} onSelect={onSelectProvider} />
					))}
				</div>

				<Alert tone="info" title="Hinweis">
					Eigener SMTP ist für alle E-Mail-Provider verfügbar (Gmail, Outlook, Yahoo, eigene Server etc.).
					Gmail-Konten verbinden Sie über &quot;Eigener SMTP&quot; mit einem App-Passwort.
				</Alert>
			</div>
		</Panel.Body>
	</>
);

ProviderSelectionStep.propTypes = {
	onSelectProvider: PropTypes.func.isRequired,
	onClose: PropTypes.func,
};

export default ProviderSelectionStep;
